<page-grid [gridConfig]="tramsInvoiceGrid" (gridClickColumn)="openInvoiceTab($event)" />